<template>

    <el-drawer
      :title="title"
      v-model="visible"
      @close="hide"
      header-class="se-help-header"
      size="50%"
      direction="rtl">

      <WebViewer url="static/img/SoftwareLicenseAgreement.pdf"/>
    </el-drawer>

</template>
<script>
import { defineComponent } from 'vue';

import {ElDrawer} from 'element-plus'
import WebViewer from 'src/components/WebViewerRO.vue'


export default defineComponent({
  emits: ['open', 'close', 'update:visible'],

  components: {
    ElDrawer,
    WebViewer
  },

  props: {
    visible: Boolean,
    title: {
      type: String,
      default: "Why is this important to Income Calculator?"
    }
  },

  data() {
    return {
      vis: this.visible
    }
  },

  watch: {
    visible(val) {
      if (val) {
        this.$emit('open');
      } else {
        this.$emit('close');
      }
    }
  },

  methods: {
    hide() {
      this.$emit('update:visible', false);
    }
  },
});
</script>
<style>
.se-help-header {
  height: 72px;
  color: white !important;
  background: #085280 !important;
  padding: 10px 10px 1rem 15px !important;
  margin-bottom: 0.5rem !important;
}

.el-drawer__body {
  height: 100%;
  box-sizing: border-box;
  overflow-y: auto;
}

.pdf-example-row {
  height: 50vh;
  /*min-height: 700px;*/
}

.title-example-pdf {
  margin-top: 0;
  color: #085280;
  font-weight: bold;
}

</style>
